// eslint-disable-next-line import/prefer-default-export
export enum QrPaymentMethodsEnum {
  "ESEWA" = "esewa",
  "KHALTI" = "khalti",
  "FONEPAY" = "fonepay",
  "BANK" = "bank",
  "NEPALPAY" = "nepalPay"
}
